import { Sun, Moon } from 'lucide-react';
import { useThemeStore } from '../../store/themeStore';

export const ThemeToggle: React.FC = () => {
  const { isDark, toggleTheme } = useThemeStore();

  return (
    <div className="flex items-center justify-between py-3">
      <span className="text-[17px]" style={{ color: 'var(--text-primary)' }}>
        Тема оформления
      </span>
      <div
        className="flex items-center gap-0 rounded-full p-1"
        style={{ backgroundColor: 'var(--bg-secondary)' }}
      >
        <button
          onClick={() => isDark && toggleTheme()}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-full transition-all"
          style={{
            backgroundColor: !isDark ? 'var(--accent)' : 'transparent',
            color: !isDark ? 'var(--accent-on)' : 'var(--text-hint)',
          }}
        >
          <Sun size={16} strokeWidth={2.5} />
          <span className="text-[15px] font-medium">Light</span>
        </button>
        <button
          onClick={() => !isDark && toggleTheme()}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-full transition-all"
          style={{
            backgroundColor: isDark ? 'var(--accent)' : 'transparent',
            color: isDark ? 'var(--accent-on)' : 'var(--text-hint)',
          }}
        >
          <Moon size={16} strokeWidth={2.5} />
          <span className="text-[15px] font-medium">Dark</span>
        </button>
      </div>
    </div>
  );
};
